<template>
  <!-- 指导员列表 -->
  <div style="padding: 20px">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" label-width="80px" :inline="true" size="mini">
        <div>
          <el-form-item label="街道">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.streetName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作社区">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.communityName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.userName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="身份证号">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.idCard" placeholder="请输入"></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">入职日期</span>
          <el-date-picker
            size="mini"
            v-model="entryDate"
            @change="entryDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
            <!-- :picker-options="expireTimeOption" -->
        </div>
        <div class="selectBox">
          <span class="selectText">离职日期</span>
          <el-date-picker
            size="mini"
            v-model="leaveDate"
            @change="leaveDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select v-model="queryParam.status" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="2"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">职位</span>
          <el-select v-model="queryParam.position" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="指导员" value="1"></el-option>
            <el-option label="组长" value="2"></el-option>
            <el-option label="片长" value="3"></el-option>
            <el-option label="巡检" value="4"></el-option>
            <el-option label="拉桶" value="5"></el-option>
            <el-option label="道路保洁" value="6"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否在保</span>
          <el-select v-model="queryParam.duringInsurance" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
          <el-button type="success" @click="addStaffFun">添加</el-button>
          <el-button type="primary" @click="handleExportXls('指导员列表', url.exportXlsUrl)">导出指导员</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.photo"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.photo"
          :preview-src-list="[slotData.data.row.photo]"
          :key="slotData.data.row.id"
        >
          <div slot="error" class="image-slot" style="width: 100px; height: 50px">
            <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button type="primary" size="mini" @click="staffHandleEdit(slotData.data.row)">编辑</el-button>
      </template>
    </e-table>

    <el-dialog :title="staffText" :visible.sync="staffDialog" :before-close="clearStaffForm">
      <el-form :model="staffForm" :rules="staffRules" ref="ruleForm">
        <el-form-item label="姓名" :label-width="staffLabelWidth" prop="userName">
          <el-input v-model="staffForm.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="年龄" :label-width="staffLabelWidth">
          <el-input v-model="staffForm.age" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="staffLabelWidth">
          <el-input v-model="staffForm.phone" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" :label-width="staffLabelWidth">
          <el-input v-model="staffForm.idCard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" :label-width="staffLabelWidth">
          <el-input v-model="staffForm.bankCard" autocomplete="off"></el-input>
        </el-form-item>
        <div class="formDiv">
          <span>入职时间</span>
          <el-date-picker
            v-model="staffForm.entryTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
            <!-- :picker-options="expireTimeOption" -->
        </div>
        <div class="formDiv">
          <span>离职时间</span>
          <el-date-picker
            v-model="staffForm.leaveTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="19:00:00"
          ></el-date-picker>
        </div>
        <el-form-item label="状态" :label-width="staffLabelWidth">
          <el-radio-group v-model="staffForm.status">
            <el-radio label="1">在职</el-radio>
            <el-radio label="2">离职</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工资" :label-width="staffLabelWidth" prop="salary">
          <el-input v-model.number="staffForm.salary" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否在保" :label-width="staffLabelWidth">
          <el-radio-group v-model="staffForm.duringInsurance">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="formDiv">
          <span>入保时间</span>
          <el-date-picker
            v-model="staffForm.insuranceDate"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </div>
        <div class="formDiv">
          <span>离保时间</span>
          <el-date-picker
            v-model="staffForm.uninsuranceDate"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </div>
        <el-form-item label="职位" :label-width="staffLabelWidth">
          <el-select v-model="staffForm.position" placeholder="请选择">
            <el-option label="指导员" value="1"></el-option>
            <el-option label="组长" value="2"></el-option>
            <el-option label="片长" value="3"></el-option>
            <el-option label="巡检" value="4"></el-option>
            <el-option label="拉桶" value="5"></el-option>
            <el-option label="道路保洁" value="6"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属街道" :label-width="staffLabelWidth">
          <el-select v-model="staffForm.streetName" placeholder="请选择街道" @change="getCommunityList">
            <el-option
              v-for="item in communityNameArr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属社区" :label-width="staffLabelWidth">
          <el-select
            v-model="staffForm.communityName"
            placeholder="请选择工作社区"
            @change="selectCommunityId"
          >
            <el-option
              v-for="item in residentialQuartersArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="负责社区"
          :label-width="staffLabelWidth"
          v-if="staffForm.position === '2' || staffForm.position === '3'"
        >
          <el-select v-model="staffForm.communityIds" multiple placeholder="请选择">
            <el-option
              v-for="item in residentialQuartersArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" :label-width="staffLabelWidth">
          <el-input type="textarea" v-model="staffForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="照片" :label-width="staffLabelWidth">
          <el-upload
            action
            ref="staffImgUpload"
            :file-list="fileList"
            :limit="1"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="importFile"
            :on-remove="staffImgRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearStaffForm">取 消</el-button>
        <el-button
          type="primary"
          :disabled="submitStaffBtnBool"
          @click="submitStaffInfo('ruleForm')"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import eTable from "@/components/table"
import { listMixin } from "@/mixins/listMixin"
import { httpAction, uploadAction } from "@/api/manage"
import { convertTime } from "@/utils/util"
export default {
  components: { eTable },
  mixins: [listMixin],
  created () {
    // this.getStaffList()
    // this.loadData(1)
  },
  mounted () {
    this.dateDefaultShow = new Date()
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1)
  },
  updated () {
    this.dataSource.forEach((item) => {
      if (Number(item.status)) item.status = this.statusCode[item.status]
      if (typeof item.duringInsurance === 'number') item.duringInsurance = this.duringInsuranceCode[item.duringInsurance]
      if (Number(item.position))
        item.position = this.positionCode[item.position]
    })
  },
  data () {
    return {
      statusCode: {
        1: "在职",
        2: "离职",
      },
      duringInsuranceCode: {
        0: '否',
        1: '是'
      },
      positionCode: {
        1: "指导员",
        2: "组长",
        3: "片长",
        4: "巡检",
        5: "拉桶",
        6: "道路保洁",
      },
      entryDate: "",
      leaveDate: "",
      dateDefaultShow: "",
      // expireTimeOption: {
      //   disabledDate (date) {
      //     return date.getTime() - 8.64e6 >= Date.now()
      //   },
      // },
      url: {
        list: "/garbageStationSorter/queryGarbageStationSorter",
        addStaffData: "/garbageStationSorter/saveOrUpdateGarbageStationSorter",
        getGarbageStationNo: "/garbageStation/garbageStation/list",
        upload: "/api/upload",
        queryArea: "/address/street/list",
        queryResidentialQuarters: "/address/community/list",
        getStationSorterDetail: "/garbageStationSorter/detail/",
        exportXlsUrl: "/garbageStationSorter/exportGss",
      },
      //字段权限
      loading: false,
      queryParam: {
        userName: "",
        streetName: "",
        communityName: "",
        phone: "",
      },
      columns: [
        { field: "streetName", label: "所属街道" },
        { field: "communityName", label: "所属社区" },
        { field: "userName", label: "姓名" },
        { field: "phone", label: "手机号", width: 100 },
        { field: "age", label: "年龄" },
        { field: "idCard", label: "身份证号", width: 150 },
        { field: "bankCard", label: "银行卡号" },
        { field: "entryTime", label: "入职时间", width: 90 },
        { field: "leaveTime", label: "离职时间", width: 90 },
        { field: "status", label: "状态" },
        { field: "salary", label: "工资" },
        { field: "duringInsurance", label: "是否在保" },
        { field: "insuranceDate", label: "入保时间" },
        { field: "uninsuranceDate", label: "离保时间" },
        { field: "position", label: "职位" },
        {
          width: 200,
          label: "图片",
          slotName: "photo",
          columnType: "slot",
        },
        { field: "remark", label: "备注", width: 200, tooltip: true },
        {
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      // 新增编辑信息
      staffText: "",
      staffDialog: false,
      staffLabelWidth: "80px",
      staffForm: {
        userName: "",
        age: null,
        phone: "",
        photo: "",
        idCard: "",
        bankCard: "",
        entryTime: "",
        leaveTime: "",
        status: "",
        salary: "",
        insuranceDate: "",
        uninsuranceDate: "",
        position: "",
        communityIds: [],
        remark: "",
        streetName: "",
        streetId: "",
        communityName: "",
        communityId: "",
        id: null,
      },
      dialogImageUrl: "",
      dialogVisible: false,
      communityNameArr: [],
      residentialQuartersArr: [],
      staffRules: {
        userName: [
          { required: true, message: "请填写姓名", trigger: "blur" },
          {
            min: 2,
            max: 12,
            message: "长度在 2 到 12 个字符",
            trigger: "blur",
          },
        ],
        salary: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
                  callback(new Error("请填写大于0的数字"))
                } else {
                  callback()
                }
              } else {
                callback()
              }

            },
            trigger: 'change'
          }
        ]
      },
      submitStaffBtnBool: false,
      fileList: [],
    }
  },
  methods: {
    entryDateChange (date) {
      if (date) {
        this.queryParam.entryTimeStart = date[0] + " 00:00:00"
        this.queryParam.entryTimeEnd = date[1] + " 23:59:59"
      } else {
        this.queryParam.entryTimeStart = ''
        this.queryParam.entryTimeEnd = ''
      }
    },
    leaveDateChange (date) {
      if (date) {
        this.queryParam.leaveTimeStart = date[0] + " 00:00:00"
        this.queryParam.leaveTimeEnd = date[1] + " 23:59:59"
      } else {
        this.queryParam.leaveTimeStart = ''
        this.queryParam.leaveTimeEnd = ''
      }
    },
    resetForm () {
      this.queryParam = {}
      this.entryDate = ""
      this.leaveDate = ""
      this.searchQuery()
    },
    async addStaffFun () {
      this.staffDialog = true
      this.staffText = "新增指导员"
      let { code, data } = await httpAction(this.url.queryArea, {}, "get")
      if (code === 200) {
        this.communityNameArr = data
      } else {
        this.$message.warning("请求失败,请重新尝试")
      }
    },
    async staffHandleEdit (row) {
      if (this.$refs["ruleForm"]) {
        this.$nextTick(() => {
          this.$refs["ruleForm"].clearValidate()
        })
      }
      this.staffDialog = true
      this.staffText = "编辑指导员详情"
      let { data: workerInfo } = await httpAction(
        this.url.getStationSorterDetail + row.id,
        {},
        "get"
      )
      let result = workerInfo.photo
        ? workerInfo.photo.split(",").reduce((pre, item, index) => {
          if (item) {
            pre.push({ uid: index, url: item })
          }
          return pre
        }, [])
        : []
      result.forEach((item) => {
        this.fileList.push(item)
      })
      let { code, data } = await httpAction(this.url.queryArea, {}, "get")
      if (code === 200) {
        this.communityNameArr = data
      } else {
        this.$message.warning("请求失败,请重新尝试")
      }
      let res = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [workerInfo.streetId] },
        "post"
      )
      this.residentialQuartersArr = res.data
      let communityIds = []
      if (workerInfo.communityIds)
        workerInfo.communityIds.forEach((item) =>
          communityIds.push(Number(item))
        )
      this.staffForm = {
        userName: workerInfo.userName,
        age: workerInfo.age ? workerInfo.age.toString() : null,
        phone: workerInfo.phone,
        photo: workerInfo.photo,
        streetId: workerInfo.streetId,
        streetName: row.streetName,
        communityId: workerInfo.communityId,
        communityName: row.communityName,
        id: workerInfo.id,
        idCard: workerInfo.idCard,
        bankCard: workerInfo.bankCard,
        entryTime: workerInfo.entryTime,
        leaveTime: workerInfo.leaveTime,
        status: workerInfo.status + "",
        salary: workerInfo.salary,
        duringInsurance: workerInfo.duringInsurance + "",
        insuranceDate: workerInfo.insuranceDate,
        uninsuranceDate: workerInfo.uninsuranceDate,
        position: workerInfo.position ? workerInfo.position + "" : "",
        communityIds,
        remark: workerInfo.remark,
      }
      // this.residentialQuartersArr = workerInfo.communityList
    },
    clearStaffForm () {
      this.staffDialog = false;
      (this.staffForm = {
        userName: "",
        age: null,
        phone: "",
        photo: "",
        streetName: "",
        communityName: "",
        id: null,
      }),
        (this.communityNameArr = [])
      this.residentialQuartersArr = []
      this.fileList = []
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate()
        this.$refs.staffImgUpload.clearFiles()
      })
    },
    async getCommunityList (val) {
      this.staffForm.communityName = ""
      let { id } = this.communityNameArr.find((item) => item.name === val)
      this.staffForm.streetId = id
      let { data } = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [id] },
        "post"
      )
      this.residentialQuartersArr = data
    },
    selectCommunityId (e) {
      this.staffForm.communityId = e
    },
    submitStaffInfo (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const timeReg = /^(\d{4})/
          if (
            this.staffForm.entryTime
              ? !timeReg.test(this.staffForm.entryTime)
              : ""
          )
            this.staffForm.entryTime = convertTime(this.staffForm.entryTime)
          if (
            this.staffForm.leaveTime
              ? !timeReg.test(this.staffForm.leaveTime)
              : ""
          )
            this.staffForm.leaveTime = convertTime(this.staffForm.leaveTime)
          if (this.staffForm.leaveTime)
            if (this.staffForm.leaveTime < this.staffForm.entryTime)
              return this.$message.warning("离职时间不能早于入职时间")

          if (
            this.staffForm.insuranceDate
              ? !timeReg.test(this.staffForm.insuranceDate)
              : ""
          ) this.staffForm.insuranceDate = convertTime(
            this.staffForm.insuranceDate
          )
          if (
            this.staffForm.uninsuranceDate
              ? !timeReg.test(this.staffForm.uninsuranceDate)
              : ""
          ) this.staffForm.uninsuranceDate = convertTime(
            this.staffForm.uninsuranceDate
          )
          this.loading = true
          if (
            this.staffForm.position != (2 || 3)
          )
            this.staffForm.communityIds = []
          let res = await httpAction(
            this.url.addStaffData,
            { ...this.staffForm },
            "post"
          )
          if (res.code === 200) {
            this.loading = false
            this.$message.success("请求成功")
            this.clearStaffForm()
            this.loadData(1)
          } else {
            this.$message.warning(res.msg)
          }
        } else {
          this.$message.error("缺少必填项")
          return false
        }
      })
    },
    beforeAvatarUpload (file) {
      let types = ["image/jpeg", "image/jpg", "image/bmp", "image/png"]
      const isIMG = types.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG、JPEG、bmp、PNG 格式!")
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!")
      }
      return isIMG && isLt10M
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    importFile (file) {
      this.submitStaffBtnBool = true
      let formData = new FormData()
      formData.append("businessType", 100)
      formData.append("file", file.file, file.file.name) // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功")
          this.staffForm.photo = res.data[0]
          this.submitStaffBtnBool = false
        })
        .catch((err) => {
          this.$message.error("上传失败")
          this.submitStaffBtnBool = false
        })
    },
    staffImgRemove () {
      this.staffForm.photo = ""
    },
    surpass () {
      this.$message.warning("最多只能上传一张图片!")
    },
  },
};
</script>

<style scoped lang="scss">
.search_wrap {
  margin: 10px 0;
}
.formDiv {
  margin-bottom: 22px;
  span {
    width: 80px;
    line-height: 36px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    cursor: default;
  }
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>